<template>
    <div v-if="!isMinimalHeader">
        <header>
            <div class="site-header" :class="{ 'site-header__legacy': !isPwa }">
                <!--        <AppBanner v-if="!isDesktop && !searchIsOpen" class="android-only-flex" :dictionary="dictionary" />-->
                <XmasBanner v-if="!searchIsOpen && isXmasSeason" :dictionary="dictionary" :show-express-and-box="showExpressAndBox" />
                <div v-if="headlineBarData" :class="{ 'd-none d-md-block': searchIsOpen }">
                    <a
                        v-if="
                            headlineBarData.redirectUrl &&
                            headlineBarData.redirectUrl.length > 0 &&
                            headlineBarData.content.indexOf('<a') < 0
                        "
                        class="headline-bar"
                        :style="`background-color: #${headlineBarData.bgColor}; color: #${headlineBarData.textColor || 'fff'}`"
                        :href="headlineBarData.redirectUrl"
                        v-html="headlineBarData.content"
                        role="link"
                    >
                    </a>
                    <div
                        v-else
                        class="headline-bar"
                        :style="`background-color: #${headlineBarData.bgColor}; color: #${headlineBarData.textColor || 'fff'}; --headline-link-color: #${headlineBarData.textColor || 'fff'}`"
                        v-html="headlineBarData.content"
                    ></div>
                </div>

                <div class="site-header__content">
                    <div class="site-header__container">
                        <!-- Link -->
                        <NuxtLink
                            v-if="isPwa"
                            to="/"
                            :title="dictionary.siteHeader.logoTitle"
                            role="link"
                            class="site-header__logo-container"
                        >
                            <img src="/nuxt-assets/design2025/logo-green.svg" class="d-block d-md-none" />
                            <img
                                :src="
                                    langDefault === 'sk'
                                        ? '/nuxt-assets/design2025/logo-with-moto-sk.svg'
                                        : '/nuxt-assets/design2025/logo-with-moto.svg'
                                "
                                class="d-none d-md-block"
                            />
                        </NuxtLink>
                        <a v-else href="/" :title="dictionary.siteHeader.logoTitle" role="link" class="site-header__logo-container">
                            <img src="/nuxt-assets/design2025/logo-green.svg" class="d-block d-md-none" />
                            <img
                                :src="
                                    langDefault === 'sk'
                                        ? '/nuxt-assets/design2025/logo-with-moto-sk.svg'
                                        : '/nuxt-assets/design2025/logo-with-moto.svg'
                                "
                                class="d-none d-md-block"
                            />
                        </a>
                        <!-- end Link -->

                        <TheSearch
                            @mobileMenu="openMenuCategory = !openMenuCategory"
                            :langDefault="langDefault"
                            :base-url="basicUrl"
                            :is-pwa="isPwa"
                            :last-visited-product-ids="lastVisitedProductIds"
                            @addProductToBasket="addProductToBasket"
                            :product-amounts="productAmounts"
                            :dictionary="dictionary"
                            :search-is-open="searchIsOpen"
                            @opened="searchIsOpen = true"
                            @closed="searchIsOpen = false"
                            @autocompleteResults="autocompleteResults"
                            @autocompleteClickResult="autocompleteClickResult"
                        />

                        <div class="site-header__right justify-content-end">
                            <button class="link d-flex d-md-none" @click.prevent="searchButtonClicked">
                                <img src="/nuxt-assets/icons/search-green.svg" width="20" />
                            </button>

<!--                            <button-->
<!--                                v-if="fastestPossibleDeliveryDate"-->
<!--                                :href="isUserAuthenticated ? dictionary.url.user.myFavorite : dictionary.url.user.login"-->
<!--                                class="link d-none d-md-block"-->
<!--                                :title="fastestPossibleDeliveryDate"-->
<!--                                @click="$emit('fastestPossibleDeliveryDateClicked')"-->
<!--                            >-->
<!--                                &lt;!&ndash;                      <img src="/nuxt-assets/images/icons/badge-delivery-black.svg" alt="Delivery date" />&ndash;&gt;-->
<!--                                <span class="site-ico__label fs-14">{{ fastestPossibleDeliveryDate }}</span>-->
<!--                            </button>-->

                            <template v-if="pilulkaProEnabled">
                                <nuxt-link v-if="isPwa" class="link pilulka-pro-link" to="/vase-pilulka-pro">
                                    <img src="/nuxt-assets/design2025/pilulka-pro-logo.svg" alt="Pilulka PRO" />
                                </nuxt-link>
                                <a v-else class="link pilulka-pro-link" href="/vase-pilulka-pro">
                                    <img src="/nuxt-assets/design2025/pilulka-pro-logo.svg" alt="Pilulka PRO" />
                                </a>
                            </template>

                            <div
                                class="user site-header__corner"
                                @mouseenter="openUserPopup"
                                @mouseleave="closeUserPopup"
                                :class="{ 'site-header__corner__active active': isUserBoxOpen }"
                            >
                                <UserPopupLogged
                                    v-if="isUserAuthenticated"
                                    :show-popup="isUserBoxOpen"
                                    :username="username"
                                    :dictionary="dictionary"
                                />
                                <UserPopupNotLogged
                                    :is-pwa="isPwa"
                                    :show-popup="isUserBoxOpen"
                                    :dictionary="dictionary"
                                    :uid="basket.uid"
                                    :base-url="basicUrl"
                                    v-else
                                    @logged="logged"
                                />

                                <a
                                    :href="dictionary.url.user.orders"
                                    v-if="isUserAuthenticated && !isPwa"
                                    class="link"
                                    :title="dictionary.siteHeader.login.orders"
                                >
                                    <img
                                        src="/nuxt-assets/images/icons/user.svg"
                                        class="d-block d-md-none"
                                        :alt="dictionary.siteHeader.login.orders"
                                    />
                                    <span class="site-ico__label fs-14 d-none d-md-block">{{ username }}</span>
                                </a>
                                <nuxt-link
                                    :to="dictionary.url.user.orders"
                                    v-if="isUserAuthenticated && isPwa"
                                    class="link"
                                    :title="dictionary.siteHeader.login.orders"
                                >
                                    <img
                                        src="/nuxt-assets/images/icons/user.svg"
                                        class="d-block d-md-none"
                                        :alt="dictionary.siteHeader.login.orders"
                                    />
                                    <span class="site-ico__label fs-14 d-none d-md-block">{{ username }}</span>
                                </nuxt-link>

                                <a
                                    :href="dictionary.url.user.login"
                                    v-if="!isUserAuthenticated && !isPwa"
                                    class="link"
                                    :title="dictionary.siteHeader.login.title"
                                >
                                    <img src="/nuxt-assets/images/icons/user.svg" class="d-block d-md-none" alt="user" />
                                    <span class="site-ico__label fs-14 d-none d-md-block">
                                        {{ dictionary.siteHeader.login.title }}
                                    </span>
                                </a>
                                <nuxt-link
                                    :to="dictionary.url.user.login"
                                    v-if="!isUserAuthenticated && isPwa"
                                    class="link"
                                    :title="dictionary.siteHeader.login.title"
                                >
                                    <img src="/nuxt-assets/images/icons/user.svg" class="d-block d-md-none" alt="user" />
                                    <span class="site-ico__label fs-14 d-none d-md-block">
                                        {{ dictionary.siteHeader.login.title }}
                                    </span>
                                </nuxt-link>
                            </div>
                            <div id="js-cart-box" class="cart d-block">
                                <div class="cart-box">
                                    <CartBox
                                        v-if="isPwa"
                                        :is-pwa="isPwa"
                                        @addProductToBasket="addProductToBasket"
                                        :basket="basket"
                                        :cart-box-banner="cartBoxBanner"
                                        :product-amounts="productAmounts"
                                        :progress-bars="progressBars"
                                        :dictionary="dictionary"
                                    />
                                </div>
                                <NuxtLink
                                    v-if="isPwa"
                                    class="link basket-link"
                                    :title="dictionary.siteHeader.menu.transport"
                                    :to="dictionary.url.cartStep1"
                                >
                                    <img class="basket-link-icon" src="/nuxt-assets/design2025/icons/basket-white.svg" alt="basket" />
                                    <img
                                        class="basket-link-icon-hover"
                                        src="/nuxt-assets/design2025/icons/basket-primary-green.svg"
                                        alt="basket"
                                    />

                                    <strong
                                        id="js-cart-amount-desktop"
                                        v-if="basket.totalAmount"
                                        class="site-header__right__link__count font-weight-bold"
                                    >
                                        {{ basket.totalAmount }}
                                    </strong>

                                    <span v-if="basket.price.afterDiscountPrice" class="site-header__right__link__text">
                                        <span
                                            id="js-cart-price-desktop"
                                            class="notranslate text-nowrap"
                                            v-html="$formatCurrency(basket.price.afterDiscountPrice)"
                                        ></span>
                                    </span>
                                </NuxtLink>
                                <a
                                    v-else
                                    class="link basket-link"
                                    :title="dictionary.siteHeader.menu.transport"
                                    :href="dictionary.url.cartStep1"
                                >
                                    <img class="basket-link-icon" src="/nuxt-assets/design2025/icons/basket-white.svg" alt="basket" />
                                    <img
                                        class="basket-link-icon-hover"
                                        src="/nuxt-assets/design2025/icons/basket-primary-green.svg"
                                        alt="basket"
                                    />

                                    <strong
                                        id="js-cart-amount-desktop"
                                        v-if="basket.totalAmount"
                                        class="site-header__right__link__count font-weight-bold"
                                    >
                                        {{ basket.totalAmount }}
                                    </strong>

                                    <span v-if="basket.price.afterDiscountPrice" class="site-header__right__link__text">
                                        <span
                                            id="js-cart-price-desktop"
                                            class="notranslate text-nowrap"
                                            v-html="$formatCurrency(basket.price.afterDiscountPrice)"
                                        ></span>
                                    </span>
                                </a>
                            </div>
                            <button class="link d-flex d-md-none" @click.prevent="openMenuCategory">
                                <img src="/nuxt-assets/design2025/icons/hamburger-menu.svg" width="20" />
                            </button>
                        </div>
                    </div>
                    <DesktopMainMenu
                        v-if="isDesktop || isTablet"
                        :items="items"
                        :menu-banners="menuBanners"
                        :menu-brand-banners="menuBrandBanners"
                        :sale-banners="saleBanners"
                        :pinned-categories="pinnedCategories"
                        :menu-item-products="menuItemProducts"
                        :xmas-category-id="xmasCategoryId"
                        :menu-highlight-category="menuHighlightCategory"
                        :product-amounts="productAmounts"
                        :dictionary="dictionary"
                        :is-pwa="isPwa"
                        @update:openMenu="openMenu = $event"
                        @menuMouseOver="$emit('menuMouseOver')"
                        @addProductToBasket="addProductToBasket"
                        @redirectToUrl="redirectToUrl"
                    >
                        <template v-slot:product="{ product }">
                            <slot name="product" v-bind="{ product }"></slot>
                        </template>
                    </DesktopMainMenu>
                </div>
            </div>
            <MobileMenuCategory
                v-if="!isDesktop"
                :items="items"
                :menu-banners="menuBanners"
                :menu-brand-banners="menuBrandBanners"
                :pinned-categories="pinnedCategories"
                :is-desktop="isDesktop"
                :open="menuOpen"
                :menu-item-products="menuItemProducts"
                :is-pwa="isPwa"
                :langDefault="langDefault"
                :xmas-category-id="xmasCategoryId"
                :menu-highlight-category="menuHighlightCategory"
                :product-amounts="productAmounts"
                :dictionary="dictionary"
                :saleBanners="saleBanners"
                @toggleMenu="openMenuCategory"
                @addProductToBasket="addProductToBasket"
                @redirectToUrl="redirectToUrl"
            >
                <template v-slot:product="{ product }">
                    <slot name="product" v-bind="{ product }"></slot>
                </template>
            </MobileMenuCategory>
        </header>
        <!--    <MainMenu-->
        <!--        :is-pwa="isPwa"-->
        <!--        :user-box-title="dictionary.siteHeader.login.label"-->
        <!--        :user-box-link="dictionary.siteHeader.login.label"-->
        <!--        :total-amount="basket.totalAmount"-->
        <!--        :total-price="basket.price.afterDiscountPrice"-->
        <!--        :user-authentication="isUserAuthenticated"-->
        <!--        :username="username"-->
        <!--        :langDefault="langDefault"-->
        <!--        :xmas-category-id="xmasCategoryId"-->
        <!--        :menu-highlight-category="menuHighlightCategory"-->
        <!--        :product-amounts="productAmounts"-->
        <!--        :dictionary="dictionary"-->
        <!--        :uid="basket.uid"-->
        <!--        :base-url="basicUrl"-->
        <!--        @toggleMenu="openMenuCategory"-->
        <!--        @addProductToBasket="addProductToBasket"-->
        <!--        @redirectToUrl="redirectToUrl"-->
        <!--        @logged="logged"-->
        <!--    />-->
    </div>
    <div v-else>
        <header class="minimal-header">
            <nav class="site-header" :class="{ 'site-header__legacy': !isPwa }">
                <div v-if="headlineBarData">
                    <a
                        v-if="
                            headlineBarData.redirectUrl &&
                            headlineBarData.redirectUrl.length > 0 &&
                            headlineBarData.content.indexOf('<a') < 0
                        "
                        class="headline-bar"
                        :style="`background-color: #${headlineBarData.bgColor}; color: #${headlineBarData.textColor || 'fff'}`"
                        :href="headlineBarData.redirectUrl"
                        v-html="headlineBarData.content"
                        role="link"
                    >
                    </a>
                    <div
                        v-else
                        class="headline-bar"
                        :style="`background-color: #${headlineBarData.bgColor}; color: #${headlineBarData.textColor || 'fff'}; --headline-link-color: #${headlineBarData.textColor || 'fff'}`"
                        v-html="headlineBarData.content"
                    ></div>
                </div>

                <div class="site-header__content">
                    <div class="site-header__container site-header__container--minimal-header container" style="flex-direction: row">
                        <!-- Link -->
                        <NuxtLink
                            v-if="isPwa"
                            to="/"
                            :title="dictionary.siteHeader.logoTitle"
                            role="link"
                            class="site-header__logo-container site-minimal-header__logo-container"
                        >
                            <img
                                :src="
                                    langDefault === 'sk'
                                        ? '/nuxt-assets/design2025/logo-with-moto-sk.svg'
                                        : '/nuxt-assets/design2025/logo-with-moto.svg'
                                "
                            />
                        </NuxtLink>
                        <a
                            v-else
                            href="/"
                            :title="dictionary.siteHeader.logoTitle"
                            role="link"
                            class="site-header__logo-container site-minimal-header__logo-container"
                        >
                            <img
                                :src="
                                    langDefault === 'sk'
                                        ? '/nuxt-assets/design2025/logo-with-moto-sk.svg'
                                        : '/nuxt-assets/design2025/logo-with-moto.svg'
                                "
                            />
                        </a>
                        <!-- end Link -->

                        <div v-if="isDesktop" class="site-minimal-header__support-container">
                            <div>
                                <img
                                    v-if="customerCareStatus === 'chat'"
                                    :src="`/nuxt-assets/images/icons/chat.svg`"
                                    alt="Chat"
                                    loading="lazy"
                                />
                                <img v-else :src="`/nuxt-assets/images/icons/phone-dark-grey.svg`" :alt="dictionary.phone" loading="lazy" />
                            </div>
                            <div class="support-container__info">
                                <a v-if="customerCareStatus === 'phone'" class="support-container__phone" :href="`tel:${dictionary.phone}`">
                                    <b>{{ dictionary.phone }}</b>
                                </a>
                                <a
                                    v-else-if="customerCareStatus === 'chat'"
                                    class="support-container__link"
                                    :href="dictionary.contact"
                                    @click="openChat"
                                >
                                    {{ dictionary.siteHeader.startChat }}
                                </a>
                                <a v-else class="support-container__link" :href="dictionary.contact">
                                    {{ dictionary.phoneAvailability }}
                                </a>
                            </div>
                        </div>

                        <div class="site-header__right justify-content-end">
                            <div
                                class="user site-header__corner"
                                @mouseenter="openUserPopup"
                                @mouseleave="closeUserPopup"
                                :class="{ 'site-header__corner__active active': isUserBoxOpen }"
                            >
                                <UserPopupLogged
                                    v-if="isUserAuthenticated"
                                    :show-popup="isUserBoxOpen"
                                    :username="username"
                                    :dictionary="dictionary"
                                />
                                <UserPopupNotLogged
                                    :is-pwa="isPwa"
                                    :show-popup="isUserBoxOpen"
                                    :dictionary="dictionary"
                                    :uid="basket.uid"
                                    :base-url="basicUrl"
                                    v-else
                                    @logged="logged"
                                />

                                <a
                                    v-if="isUserAuthenticated"
                                    :href="dictionary.url.user.orders"
                                    class="link"
                                    :title="dictionary.siteHeader.login.title"
                                    tabindex="-1"
                                >
                                    <!--                  <img src="/nuxt-assets/images/icons/user.svg" :alt="username" />-->
                                    <span class="site-ico__label fs-14">{{ username }}</span>
                                </a>

                                <a
                                    v-if="!isUserAuthenticated"
                                    :href="dictionary.url.user.login"
                                    class="link"
                                    :title="dictionary.siteHeader.login.title"
                                    tabindex="-1"
                                >
                                    <!--                  <img src="/nuxt-assets/images/icons/user.svg" alt="user" />-->
                                    <span class="site-ico__label fs-14">
                                        {{ dictionary.siteHeader.login.title }}
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    </div>
</template>

<script>
import DesktopMainMenu from './desktop/MainMenu'
import TheSearch from './elements/TheSearch'
import UserPopupNotLogged from './elements/UserPopupNotLogged'
import UserPopupLogged from './elements/UserPopupLogged'
import CartBox from './elements/CartBox'
import MobileMenuCategory from './mobile/MenuCategory'
// import AppBanner from "./elements/AppBanner";
import XmasBanner from './elements/XmasBanner.vue'

export default {
    name: 'TheHeader',

    components: {
        XmasBanner,
        DesktopMainMenu,
        TheSearch,
        UserPopupNotLogged,
        CartBox,
        MobileMenuCategory,
        UserPopupLogged,
    },

    props: {
        productAmounts: {
            type: Object,
            required: false,
            default: () => {},
        },
        progressBars: {
            type: Array,
            default: () => {
                return []
            },
        },
        lastVisitedProductIds: {
            type: Array,
            required: false,
            default: () => {
                return []
            },
        },
        isPwa: {
            type: Boolean,
            required: true,
        },
        cartBoxBanner: {
            type: Object,
        },
        basket: {
            type: Object,
            required: true,
        },
        isDesktop: {
            type: Boolean,
            default: true,
        },
        isTablet: {
            type: Boolean,
            default: false,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
        items: {
            default: false,
        },
        pinnedCategories: {
            default: false,
        },
        menuBanners: {
            type: Array,
        },
        menuBrandBanners: {
            type: Array,
        },
        saleBanners: {
            type: Array,
            default: null,
        },
        isUserAuthenticated: {
            type: Boolean,
            default: false,
        },
        isUserPremium: {
            type: Boolean,
            default: false,
        },
        username: {
            type: String,
            default: '',
        },
        basicUrl: {
            type: String,
            default: '',
        },
        favoriteCount: {
            type: Number,
            default: 0,
            required: true,
        },
        langDefault: {
            type: String,
            default: '',
        },
        menuItemProducts: {
            default: false,
        },
        xmasCategoryId: {
            type: Number,
            required: false,
        },
        menuHighlightCategory: {
            type: Number,
            required: false,
        },
        headlineBarData: {
            type: Object,
            required: false,
        },
        dictionary: {
            type: Object,
            required: true,
        },
        isMinimalHeader: {
            type: Boolean,
            default: false,
            required: false,
        },
        isXmasSeason: {
            type: Boolean,
            default: false,
            required: false,
        },
        fastestPossibleDeliveryDate: {
            type: String,
            default: '',
        },
        customerCareStatus: {
            type: String,
            default: 'closed',
        },
        pilulkaProEnabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            searchIsOpen: false,
            isUserBoxOpen: false,
            openMenu: false,
            menuOpen: false,
            lastScrollTop: 0,
            pageYOffset: 0,
        }
    },

    computed: {
        strippedSupportLink() {
            let regex = /(<([^>]+)>)/gi
            return this.dictionary.chat.replace(regex, ' ')
        },

        showExpressAndBox() {
            return this.langDefault === 'cz' || this.langDefault === 'sk'
        },
    },

    mounted() {
        this.onScroll()

        /* For Desktop */
        window.addEventListener('scroll', () => {
            if (!document.getElementById('mainMenu')?.classList.contains('menu--opened')) {
                this.onScroll()
            }
        })
        /* For Mobile */
        document.getElementById('__nuxt')?.addEventListener('scroll', () => {
            this.onScroll()
        })
    },

    methods: {
        searchButtonClicked() {
            this.searchIsOpen = true
            document.body.classList.add('noscroll')
            setTimeout(() => {
                document.getElementById('js-search-form-q').focus()
            })
        },
        logged(data) {
            this.$emit('logged', data)
        },

        openChat(e) {
            if (window.chat) {
                e.preventDefault()

                window.loadAndOpenAmioChat()
            } else {
                return true
            }
        },

        addProductToBasket(data) {
            this.$emit('addProductToBasket', data)
        },

        autocompleteResults(queryString, items) {
            this.$emit('autocompleteResults', queryString, items)
        },

        autocompleteClickResult(clickType, item) {
            this.$emit('autocompleteClickResult', clickType, item)
        },

        openMenuCategory() {
            this.menuOpen = !this.menuOpen
            if (this.menuOpen) {
                this.$emit('menuIsVisible')
                localStorage.setItem('pageYOffset', window.pageYOffset)
                setTimeout(() => {
                    document.body.classList.add('fixed-page')
                }, 0)
            } else {
                setTimeout(() => {
                    document.body.classList.remove('fixed-page')
                }, 0)
                window.scrollTo(0, parseInt(localStorage.getItem('pageYOffset')))
            }
        },
        openUserPopup() {
            this.isUserBoxOpen = true
        },
        closeUserPopup() {
            if (document.activeElement.tagName !== 'INPUT') {
                this.isUserBoxOpen = false
            }
        },
        onScroll() {
            const st = window.pageYOffset || document.documentElement.scrollTop || document.getElementById('__nuxt')?.scrollTop
            const bodyClassList = document.body.classList

            if (bodyClassList.contains('modal-open')) {
                return
            }

            if (!this.openMenu && this.isPwa) {
                st > this.lastScrollTop ? bodyClassList.add('header-sticky') : bodyClassList.remove('header-sticky')

                this.lastScrollTop = st <= 0 ? 0 : st
            }
        },
        redirectToUrl(data) {
            this.$emit('redirectToUrl', data)
        },
    },
}
</script>
<style lang="scss">
$breakPointForSmallHeader: 768px;

header {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue,
        sans-serif;
}

.minimal-header {
    @media (min-width: 768px) {
        margin-bottom: -50px;
    }
}

.cart-box {
    position: absolute;
    display: none;
    top: 100%;
    margin-top: -1px;
    right: 0;
    background: #fff;
    padding: 10px;
    width: 540px;
    font-size: 14px;
    z-index: 999;

    @media (max-width: 767.98px) {
        position: fixed;
        top: 47px;
        width: 100%;
        left: 0;
        bottom: 0;
        background: #fff;
    }

    @media (min-width: 768px) {
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
    }

    &--open {
        display: block;
        z-index: 20;

        @media (hover: none) {
            display: none;
        }
    }

    &__contents {
        max-height: 50vh;
        overflow-y: auto;
    }

    &__footer {
        background: #ffffff;
        margin: 15px -10px -10px;

        .progress {
            background: #ffffff;
            height: 36px;
            border: 2px solid #ecf4d9;
            border-radius: 36px;
        }

        .free-delivery-status-text {
            top: 8px;
        }

        .progress-bar {
            background: #ecf4d9;
        }
    }

    &__delivery-text {
        background: #dbf1da;
        font-size: 13px;
        border-radius: 8px;
    }
}

.loadPrice {
    color: #ddd;
}
.cart {
    position: relative;
    display: flex;
    justify: content-end;
    z-index: 200;
    //min-width: 111px;

    &:hover {
        @media (min-width: 768px) {
            .basket-link-icon {
                display: none;
            }
            .basket-link-icon-hover {
                display: inline;
            }

            .link {
                box-shadow: 0 -2px 12px #00000019;
                border-radius: 10px;
                background-color: #ffffff;
                color: #064740;

                &:after {
                    width: 100%;
                    height: 18px;
                    background: #fff;
                    position: absolute;
                    bottom: -9px;
                    left: 0;
                    content: '';
                    //box-shadow: 5px 0 4px -5px #00000019;
                }
            }

            .cart-box {
                display: block;
            }
        }
    }
}

.user.active {
    @media (min-width: 768px) {
        position: relative;
        display: flex;
        z-index: 200;

        .link {
            box-shadow: 0 -2px 12px #00000019;
            border-radius: 10px;
            background-color: #ffffff;

            &:after {
                width: 100%;
                height: 18px;
                background: #fff;
                position: absolute;
                z-index: 9;
                bottom: -9px;
                left: 0;
                content: '';
                //box-shadow: 5px 0 4px -5px #00000019;
            }
        }
    }
}

.site-header {
    position: fixed;
    top: 0;
    z-index: 310;
    left: 0;
    right: 0;
    background: #fff;
    //box-shadow: 0 4px 4px -2px #00000014;
    transition: transform 0.5s;

    border-bottom: 1px solid #f2f2e9;

    .headline-bar {
        color: #fff;
        padding: 0.5rem 1rem;
        text-align: center;
        font-size: 13px;
        align-items: center;
        display: flex;
        justify-content: center;

        @media (max-width: $breakPointForSmallHeader) {
            min-height: 48px;
        }

        p {
            margin: 0;
            font-size: 13px;
        }

        b {
            color: #fff;
        }

        a {
            color: var(--headline-link-color, #fff);
            text-decoration: underline;

            &:hover {
                color: var(--headline-link-color, #fff);
                text-decoration: none;
            }
        }
    }

    &__content {
        //padding: 0 15px;
    }

    .site-minimal-header__support-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
    }

    .support-container__info {
        display: flex;
        flex-direction: column;
    }

    .support-container__link {
        color: #333333;
        text-decoration: underline;
        font-size: 12px;
    }

    .support-container__phone {
        color: #333333;
        font-size: 12px;
    }

    &.site-header--open {
        //box-shadow: inset 0 -1px 3px 1px #00000014;
    }
    a {
        text-decoration: none;
    }

    &__container {
        display: grid;
        justify-content: space-between;
        grid-template-columns: auto 1fr;
        align-items: center;
        max-width: 100%;
        margin: 0 auto;
        padding: 0 10px;

        @media (min-width: 768px) {
            padding: 0 20px;
            grid-template-columns: 230px auto max-content;
            justify-content: normal;
        }
    }
    &__corner {
        &:hover {
            &:after {
                content: '';
                width: 15px;
                height: 15px;
                position: absolute;
                bottom: 0;
                border-top: 0;
                //background: #F2F2E9;
                z-index: 101;
            }

            &:after {
                border-left: 0;
                border-radius: 0 0 5px 0;
                left: -15px;
                //box-shadow: inset -8px -6px 6px -5px #00000014;
                bottom: 1px;
            }
        }
    }
    &__center {
        display: none;
        flex-grow: 1;
        flex-wrap: wrap;
        width: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 201;
        background: #fff;

        &--visible {
            display: flex;
        }

        @media (min-width: $breakPointForSmallHeader) {
            display: flex;
            position: relative;
            background: transparent;
            justify-content: center;
        }

        &__top {
            display: flex;
            //align-items: center;
            justify-content: center;
            flex-grow: 1;
        }

        &__bottom {
            display: flex;
        }
    }
    &__right {
        display: flex;
        flex-direction: row;
        padding: 5px 0;
        gap: 5px;
        align-items: center;

        @media (min-width: $breakPointForSmallHeader) {
            gap: 10px;
        }

        &__link--active {
            box-shadow: 0 -2px 12px #00000019;
            border-radius: 10px;
            position: relative;

            &::after {
                position: absolute;
                bottom: -5px;
                left: -10px;
                width: 108%;
                height: 13px;
                background: #fff;
                content: '';
                z-index: 100;
            }
        }

        .link {
            gap: 10px;
            display: flex;
            flex-direction: row;
            padding: 9px 11px 7px;
            position: relative;
            color: #064740;
            z-index: 50;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            cursor: pointer;
            background: transparent;
            border: 0;

            img {
                height: 20px;
                position: relative;
                z-index: 10;
            }

            span {
                position: relative;
                z-index: 10;
            }

            &__text {
                display: inline-block;
                padding: 0 0 0 10px;
                text-overflow: ellipsis;
                white-space: nowrap;

                &--hideable {
                    display: none;

                    @media (min-width: 992px) {
                        display: inline-block;
                    }
                }
            }

            &__count {
                border-radius: 50%;
                position: absolute;
                color: #fff;
                background: #146154;
                text-align: center;
                width: 20px;
                height: 20px;
                line-height: 20px;
                top: 0;
                left: 26px;
                font-size: 11px;
            }
        }

        .basket-link-icon {
            display: inline;
        }
        .basket-link-icon-hover {
            display: none;
        }

        .pilulka-pro-link {
            color: #064740;
            background: #064740;
            border-radius: 30px;
            display: none;
            padding: 9px 15px 9px;

            @media (min-width: $breakPointForSmallHeader) {
                display: block;
            }

            img {
                width: 72px;
            }
        }

        .basket-link {
            background: #064740;
            color: #fff;
            border-radius: 30px;
            padding: 10px 13px;
        }
    }
    &__logo-container {
        width: 80px;
        height: auto;
        margin: 0;
        display: flex;
        align-items: center;

        @media (min-width: $breakPointForSmallHeader) {
            max-width: 230px;
            height: 54px;
            margin: 0 20px 0 0;
            width: 100%;
        }
    }

    &__pinned-category,
    &__static-link {
        display: none;

        @media (min-width: $breakPointForSmallHeader) {
            display: flex;
            align-items: center;
            padding: 0 10px;
            border: 1px solid transparent;
            border-radius: 4px;
            border-bottom: 0;
            font-size: 14px;
            position: relative;
            color: #333333;
            white-space: nowrap;
        }

        &:hover {
            color: #146154;
            text-decoration: none;
        }

        span {
            line-height: 40px;
        }

        &:nth-child(n + 7) {
            display: none;
        }

        @media (max-width: 1199.98px) {
            &:nth-child(n + 5) {
                display: none;
            }
        }

        @media (max-width: 991.98px) {
            &:nth-child(n + 4) {
                display: none;
            }
        }

        img {
            margin-right: 5px;
        }
    }
    &--mobile-navigation-open {
        .site-header {
            &__logo {
                display: none;
            }

            &__static-link {
                display: none;
            }

            &__pinned-category {
                display: none;
            }

            &__center__top {
                margin-top: 0;
            }

            &__right__link {
                display: none;
            }
        }
    }
}

.header-sticky {
    .site-header {
        transition: transform 0.5s;
        transform: translateY(-200px);
        position: fixed;

        &__placeholder {
            display: block;
            height: 100px;
            flex: none;
            @media (min-width: 992px) {
                height: 134px;
            }
        }

        &__center {
            justify-content: center;
            padding-left: 0;
            padding-top: 0;

            &__top {
                order: 2;
                margin-top: 0;
            }

            &__bottom {
                order: 1;
            }
        }

        .whisperer-wrapper {
            @media (min-width: 1000px) {
                width: 100%;
                margin-left: 10px;
            }
        }

        &__pinned-category {
            &:nth-child(n + 4) {
                display: none;
            }

            @media (max-width: 1199.98px) {
                &:nth-child(n + 3) {
                    display: none;
                }
            }

            @media (max-width: 991.98px) {
                display: none;
            }
        }

        &__static-link {
            display: none;
        }

        @media (max-width: 992px) {
            &__logo {
                display: none;
            }

            &__right__link {
                display: none;
            }
        }
    }
}

.site-ico__label {
    white-space: nowrap;
    color: #064740;
    max-width: 115px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.site-header__right__link__count {
    background: #fccce6;
    position: absolute;
    color: #064740;
    width: 17px;
    height: 17px;
    border-radius: 17px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -2px;
    left: 22px;
    z-index: 10;
}

@media (max-width: $breakPointForSmallHeader) {
    .site-header__container {
        flex-direction: column;
        padding-top: 10px;
        padding-bottom: 10px;
    }
}

@media (max-width: $breakPointForSmallHeader) {
    .site-menu-container {
        background: #fff;
        display: none;
        overflow-y: auto;
    }
}

.noscroll .pageWrap > div {
    overflow: hidden;
}

.xmasBanner {
    display: flex;
    background-color: #567746;
    padding: 7px 15px;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;
    color: #fff;
}

.xmasBanner__guarantee {
    display: flex;
    align-items: center;
    gap: 10px;

    a {
        font-size: 12px;
        text-decoration: underline;
        color: #fff;

        &:hover {
            text-decoration: none;
        }
    }
}

.xmasBanner__pilulka-express {
    display: none;

    @media (min-width: 768px) {
        display: flex;
        align-items: center;
        gap: 10px;

        &-header {
            font-weight: bold;
        }
    }
}

.xmasBanner__pilulka-box {
    display: none;

    @media (min-width: 768px) {
        display: flex;
        align-items: center;
        gap: 10px;

        &-header {
            font-weight: bold;
        }
    }
}

.lg-only {
    @media (min-width: 768px) and (max-width: 1100px) {
        display: none !important;
    }
}

.minimal-header .site-header__container {
    @media (max-width: 768px) {
        grid-template-columns: 180px auto;
        justify-content: space-between;
        justify-items: normal;
        padding: 0 10px;
    }
}
</style>
